<template>
  <div class="new-vehicle">
    <page-header
      title="Edit Fleet"
      :back="-1"
      breadcrumb="Dashboard > Settings > Vehicles >  Edit Fleet"
    />
    <div class="custom-card">
      <div class="flex items-center">
        <div class="w-6/12">
          <el-tooltip class="item mb-2" effect="dark" placement="top-start">
            <div slot="content">
              When you register a fleet as public, you allow other carriers to
              search,<br />
              discover, and use your fleet temporarily as part of theirs<br />
              and consign shipments to it. It helps you keep your fleets busy
              <br />
              and ensure they never run empty when they travel to destinations
              <br />
              that are not core to you. You can define how you prefer to
              split<br />
              the revenue with 3rd party carriers who use your fleet.
            </div>

            <span class="flex">
              <abbr class="mr-2">Fleet type </abbr>
              <img
                src="@/assets/images/icons/info.svg"
                alt="information icon"
              />
            </span>
          </el-tooltip>
          <div class="flex items-center py-2 mb-4">
              <label for="private" class="radio-label label mr-4">
                <input
                  type="radio"
                  id="private"
                  value="private"
                  v-model="newVehicle.fleetType"
                />
                Private
                <span></span>
              </label>
  
              <label for="public" class="radio-label label">
                <input
                  type="radio"
                  id="public"
                  value="public"
                  v-model="newVehicle.fleetType"
                />
                Public
                <span></span>
              </label>
          </div>
        </div>
      </div>
      <p class="text-primary-yellow font-semibold">Vehicle Name</p>
      <div class="mt-3 container-fluid">
        <div class="row">
          <div class="col-md-6 col-lg-4 col-12">
            <label class="label">Vehicle Type</label>
            <el-select
              v-model="newVehicle.vehicletype"
              placeholder="Select Type"
            >
              <el-option label="Truck" value="Truck"></el-option>
              <el-option label="Bus" value="Bus"></el-option>
              <el-option label="van" value="van"></el-option>
              <el-option label="Lorry" value="Lorry"></el-option>
              <el-option label="Car" value="car"></el-option>
              <el-option label="Bike" value="Bike"></el-option>
            </el-select>
          </div>
          <div class="col-md-6 col-lg-4 col-1">
            <label class="label">Vehicle Name</label>
            <input type="text" class="input" v-model="newVehicle.equipment" />
          </div>
          <div class="col-md-6 col-lg-4 col-1">
            <label class="label">Vehicle Number</label>
            <input
              type="text"
              class="input"
              v-model="newVehicle.vehicleNumber"
            />
          </div>
        </div>
      </div>
      <hr class="mb-2" />

      <div class="vehicle-identification">
        <div class="mb-4">
          <p class="text-primary-yellow font-semibold">
            Vehicle Identification
          </p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">VIN Number</label>
              <input type="text" class="input" v-model="newVehicle.vinnumber" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Chasis Number</label>
              <input
                type="text"
                class="input"
                v-model="newVehicle.chassisnumber"
              />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Asset Tag</label>
              <input type="text" class="input" v-model="newVehicle.assettag" />
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-2" />

      <div class="vehicle-capacity">
        <div class="mb-4">
          <p class="text-primary-yellow font-semibold">
            Vehicle Capacity
          </p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Max. Allowable Weight</label>
              <input type="text" class="input" v-model="newVehicle.currentLoadCapacity" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Max. Weight</label>
              <input type="text" class="input" v-model="newVehicle.carriageCapacity" />
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Weight Unit</label>
              <el-select v-model="newVehicle.unitOfWeight" placeholder="Select Type">
                <el-option label="milligram" value="mg"></el-option>
                <el-option label="gram" value="g"></el-option>
                <el-option label="kilogram" value="kg"></el-option>
                <el-option label="ounce" value="oz"></el-option>
                <el-option label="pound" value="lg"></el-option>
                <el-option label="metric tonne" value="mt"></el-option>
                <el-option label="ton" value="t"></el-option>
              </el-select>
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Dimension Unit</label>
              <el-select v-model="newVehicle.unitOfDimension" placeholder="Select Type">
                <el-option label="millimeter" value="mm"></el-option>
                <el-option label="centimeter" value="cm"></el-option>
                <el-option label="meter" value="m"></el-option>
                <el-option label="kilometer" value="km"></el-option>
                <el-option label="inch" value="in"></el-option>
                <el-option label="feet" value="ft"></el-option>
                <el-option label="yard" value="yd"></el-option>
              </el-select>
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label w-full block">L x W x H</label>
              <div class="w-full flex items-center justify-between">
                <input type="number" placeholder="--Enter--" class="input_Dim" v-model="newVehicle.length" />
                <input type="number" placeholder="--Enter--" class="input_Dim" v-model="newVehicle.width" />
                <input type="number" placeholder="--Enter--" class="input_Dim" v-model="newVehicle.height" />
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-12">
              <label class="label">Max. Allowable Volume</label>
              <input type="number" class="input" v-model="newVehicle.maxVolume" />
            </div>

          </div>
        </div>
      </div>

      <hr class="mb-2" />

      <div class="registered-to">
        <div class="mb-4">
          <p class="text-primary-yellow font-semibold">
            Registered To
          </p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 col-lg-6 col-12">
              <label class="label flex items-center justify-between"
                >Terminals
                <span
                  >Register across all terminals
                  <el-switch :disabled="true" v-model="newVehicle.allTerminal"
                /></span>
              </label>
              <el-select
                @input="setLocationId"
                :disabled="newVehicle.allTerminal"
                v-model="newVehicle.terminals"
                placeholder="Select"
              >
                <el-option
                  v-for="terminal in terminals"
                  :key="terminal.id"
                  :label="terminal.locationName"
                  :value="terminal.id"
                >
                </el-option>
              </el-select>
            </div>

            <div class="col-md-6 col-lg-6 col-12">
              <label class="label flex items-center justify-between"
                >Routes
                <span
                  >Register across all routes
                  <el-switch :disabled="true" v-model="newVehicle.allRoute"
                /></span>
              </label>

              <el-select
                :disabled="newVehicle.allRoute"
                v-model="newVehicle.routes"
                placeholder="Select"
              >
                <el-option
                  v-for="route in filteredRoutes"
                  :key="route.id"
                  :label="getRouteName(route)"
                  :value="route.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-4" />

      <div class="vehicle-particulars">
        <div class="flex justify-between mt-8">
          <p class="text-primary-yellow font-semibold">Vehicle Particulars</p>
          <button class="px-4 py-2 bg-primary-yellow rounded">
            Add Vehicle Particulars
          </button>
        </div>
        <div class="particulars-table">
          <table class="custom-table responsive-table">
            <thead>
              <tr class="shadow-table rounded-lg">
                <th>Vehicle Particulars</th>
                <th>Document Number</th>
                <th>File Type</th>
                <th>Expiry Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="shadow-table rounded-lg">
                <td>License & Registration</td>

                <td>{{ licenseAndRegistration ? licenseAndRegistration.licenseNumber : "N/A" }}</td>

                <td class="text-primary-yellow font-semibold">
                  <a
                    :href="licenseAndRegistration ? licenseAndRegistration.imageUrl : 'N/A'"
                    target="_blank"
                    >{{
                      licenseAndRegistration.imageUrl
                        ? "License & Registration"
                        : "N/A"
                    }}</a
                  >
                </td>

                <td>
                  <span v-if="licenseAndRegistration.expiryDate">
                    {{
                      new Date(
                        Date.parse(licenseAndRegistration.expiryDate)
                      ).toLocaleDateString("en-gb")
                    }}</span
                  >
                  <span v-else>-</span>
                </td>

                <td class="update">
                  <!-- <button><img src="@/assets/images/icons/yellow_eye.svg"/></button> -->
                  <button
                    class="mx-3"
                    @click="addParticular('licenseAndRegistration')"
                  >
                    <img src="@/assets/images/icons/green_edit.svg" />
                  </button>
                  <!-- <button><img src="@/assets/images/icons/red_delete.svg"/></button> -->
                </td>
              </tr>

              <tr class="shadow-table rounded-lg">
                <td>Insurance cert.</td>
                <td>{{ insuranceCertificate ? insuranceCertificate.licenseNumber : 'N/A' }}</td>
                <td>
                  <!-- <a
                    :href="insuranceCertificate ? insuranceCertificate.imageUrl : 'N/A'"
                    target="_blank"
                    >{{
                      insuranceCertificate.imageUrl ? "Insurance cert" : "N/A"
                    }}</a
                  > -->
                </td>
                <td>
                  <span v-if="insuranceCertificate.expiryDate">
                    {{
                      new Date(
                        Date.parse(insuranceCertificate.expiryDate)
                      ).toLocaleDateString("en-gb")
                    }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td class="update">
                  <!-- <button><img src="@/assets/images/icons/yellow_eye.svg"/></button> -->
                  <button
                    class="mx-3"
                    @click="addParticular('insuranceCertificate')"
                  >
                    <img src="@/assets/images/icons/green_edit.svg" />
                  </button>
                  <!-- <button><img src="@/assets/images/icons/red_delete.svg"/></button> -->
                </td>
              </tr>
              <tr class="shadow-table rounded-lg">
                <td>RWC</td>
                <td>{{ rwc ? rwc.licenseNumber : 'N/A'}}</td>
                <td>
                  <a
                    class="hover:no-underline"
                    :href="rwc ? rwc.imageUrl : 'N/A'"
                    target="_blank"
                    >{{ rwc.imageUrl ? "RWC" : "N/A" }}</a
                  >
                </td>
                <td>
                  <span v-if="rwc.expiryDate">
                    {{
                      new Date(Date.parse(rwc.expiryDate)).toLocaleDateString(
                        "en-gb"
                      )
                    }}</span
                  >
                  <span v-else>-</span>
                </td>
                <td class="update">
                  <!-- <button><img src="@/assets/images/icons/yellow_eye.svg"/></button> -->
                  <button class="mx-3" @click="addParticular('rwc')">
                    <img src="@/assets/images/icons/green_edit.svg" />
                  </button>
                  <!-- <button><img src="@/assets/images/icons/red_delete.svg"/></button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="button-wrapper my-5">
        <button @click="$router.push({ name: 'Vehicles' })">
          Cancel
        </button>
        <base-button
          @click="updateVehicleDetails"
          :disabled="chkParticulars"
          :loading="updateVehicle"
          text="Update"
        />
      </div>

      <add-particulars-modal
        :show-modal="isParticularsModal"
        @close-modal="isParticularsModal = false"
        :particulars-name="particularsName"
        @save-particulars="saveParticulars($event)"
        @remove-particulars="removeParticulars($event)"
        :editProps="editProps"
      />

      <SearchPublicFleetModal
        :show-modal="searchPublicFleet"
        @close-modal="searchPublicFleet = false"
        @showPublicFleetFunc="showPublicFleetFunc"
      />
      <PublicFleet
        @updatePublicFleet="updatePublicFleet"
        :show-modal="showPublicFleet"
        @close-modal="showPublicFleet = false"
      />
    </div>
  </div>
</template>

<script>
import AddParticularsModal from "../partials/AddParticularsModal";
import SearchPublicFleetModal from "../partials/SearchPublicFleetsModal.vue";
import PageHeader from "@/components/UI/NewPageHeader";
import PublicFleet from "../partials/PublicFleet.vue";

export default {
  components: {
    AddParticularsModal,
    PageHeader,
    SearchPublicFleetModal,
    PublicFleet,
  },
  data() {
    return {
      newVehicle: {
        orgId: localStorage.getItem("organizationId"),
        vinnumber: "",
        chassisnumber: "",
        equipment: "",
        assettag: "",
        vehicletype: "",
        carriageCapacity: "",
        terminals: null,
        currentLoadCapacity: "",
        vehicleNumber: "",
        lrNumber: "null",
        routes: "",
        vehicleparticulars: [],
        locationId: "",
        fleetType: "private",
        allRoute: false,
        allTerminal: false,
      },
      editProps: {},
      searchPublicFleet: false,
      terminals: [],
      routes: [],
      allTerminals: false,
      allRoutes: false,
      showPublicFleet: false,
      driverLicense: {
        licenseNumber: "",
        particulars: "",
        expiryDate: "",
        imageUrl: "",
      },
      licenseAndRegistration: {
        licenseNumber: "",
        particulars: "",
        expiryDate: "",
        imageUrl: "",
      },
      insuranceCertificate: {
        licenseNumber: "",
        particulars: "",
        expiryDate: "",
        imageUrl: "",
      },
      rwc: {
        licenseNumber: "",
        particulars: "",
        expiryDate: "",
        imageUrl: "",
      },
      updateVehicle: false,
      isParticularsModal: false,
      particularsName: "",
      fleet: {},
    };
  },
  mounted() {
    // this.getAllRoutes();
    this.getAllTerminals();
    this.$route.params?.id == "public" && (this.showPublicFleet = true);
    this.newVehicle.fleetType = this.$route.params?.id;
    this.getSingleFleet();
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newVehicle);
    },

    filteredRoutes() {
      return this.routes;
    },
    chkParticulars() {
      return this.rwc?.imageUrl?.length == 0 ||
        this.insuranceCertificate?.imageUrl?.length == 0 ||
        this.licenseAndRegistration?.imageUrl?.length == 0 ||
        this.newVehicle.vinnumber.length == 0 ||
        (!this.newVehicle.routes && !this.newVehicle.allRoute) ||
        (!this.newVehicle.terminals && !this.newVehicle.allTerminal)
        ? true
        : false;
    },
  },
  watch: {
    "newVehicle.fleetType"(val) {
      val == "public" ? (this.showPublicFleet = true) : null;
    },
    "newVehicle.terminals"(){
       this.newVehicle.routes = ""
       this.getAllRoutes()
    },
    newVehicle: {
      handler(val) {
        console.log(JSON.stringify(val, null, 2));
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getRouteName(val) {
      const routeName = val.routeName || val.routeCities.map((item) => item.cityName).join(", ")
      return (
        routeName.substring(0, 30) + (routeName.length > 30 ? "..." : '') 
      );
    },
    async setLocationId(val) {
      this.newVehicle.locationId = val;
      this.routes = [];
      await this.getAllRoutes();
    },
    updatePublicFleet(val) {
      this.newVehicle = { ...this.newVehicle, ...val };
    },
    showPublicFleetFunc() {
      this.showPublicFleet = true;
    },
    disabledEndDate(date) {
      return date.getTime() > Date.now();
    },
    async getSingleFleet() {
      const id = this.$route.params?.id;
      try {
        let response = await this.$_getSingleFleet(id);
        this.fleet = response.data.data;
        this.newVehicle = this.fleet;
        if (this.newVehicle.fleetParticulars.length) {
          this.newVehicle?.fleetParticulars.length > 0 && (this.licenseAndRegistration = this.newVehicle?.fleetParticulars[0]);
          this.newVehicle?.fleetParticulars.length > 1 && (this.insuranceCertificate = this.newVehicle?.fleetParticulars[1]);
          this.newVehicle?.fleetParticulars.length > 2 && (this.rwc = this.newVehicle?.fleetParticulars[2]);
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateVehicleDetails() {
      this.updateVehicle = true;
      const payload = {
        ...this.newVehicle,
        isPublic: this.newVehicle.fleetType == "private" ? false : true,
        fleetParticulars: [
          this.licenseAndRegistration,
          this.insuranceCertificate,
          this.rwc,
        ],
      };

      await this.$_updateFleet(this.newVehicle.id, payload);

      this.generateToast("Fleet has been updated successfully", "success");
      this.$router.push({ name: "Vehicles" });
      this.updateVehicle = false;
    },

    async getAllTerminals() {
      this.terminals = [];

      try {
        let response = await this.$_getAll3plLocations();

        this.terminals = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },

    async getAllRoutes() {
      try {
        const  response = await this.$_getAllRoutes({takeOffId : this.newVehicle.terminals});
        this.routes = response.data.data.shippingServices;
      } catch (error) {
        this.handleError(error);
      }
    },

    createTerminalsArray(terminals) {
      terminals.forEach((terminal) => {
        this.terminals.push(terminal.terminal[0]);
      });

      this.terminals = this.terminals.filter(Boolean);
    },

    resetInputFied() {
      this.newVehicle = {
        equipment: "",
        vinnumber: "",
        chassisnumber: "",
        assettag: "",
        terminals: "",
        routes: "",
        vehicletype: "",
        carriageCapacity: "",
        currentLoadCapacity: "",
        vehicleparticulars: [],
      };
    },

    addParticular(particularsName) {
      this.particularsName = particularsName;
      this.isParticularsModal = true;
      switch (particularsName) {
        case "driverLicense":
          this.editProps = this.driverLicense;
          break;
        case "licenseAndRegistration":
          this.editProps = this.licenseAndRegistration;
          break;
        case "insuranceCertificate":
          this.editProps = this.insuranceCertificate;
          break;
        case "rwc":
          this.editProps = this.rwc;
          break;
      }
    },

    saveParticulars(data) {
      this[data.name] = {
        licenseNumber: data.particulars?.documentnumber,
        particulars: null,
        expiryDate: data.particulars?.expirydate,
        imageUrl: data?.particulars?.imageurl,
      };
    },
    removeParticulars(data) {
      data;
      // this[data.name] = {
      //   licenseNumber: data.particulars.documentnumber,
      //   particulars: null,
      //   expiryDate: data.particulars.expirydate,
      //   imageUrl: data.particulars.imageurl,
      // };
    },
  },
};
</script>

<style scoped>
.update {
  color: #f57a4d;
  font-weight: bold;
  cursor: pointer;
}

.w-30 {
  width: 30%;
}
.input_Dim {
  display: block;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
  width: 32%;
  height: 2.65rem;
  padding: 0 0.5rem;
  margin-bottom: 1rem;
}
</style>
